import React from 'react';
import PropTypes from 'prop-types';

const TextAreaComponent = ({
  input,
  placeholder,
  wrapperClassName,
  inputClassName,
  errorClassName,
  showErrorText,
  id,
  labelText,
  labelClass,
  meta: { touched, error },
  focus,
  additional,
  maxLength,
  counter,
  asterisk,
}) => (
  <div className={`${wrapperClassName} ${touched && error ? 'wrapper-error' : ''}`}>
    <div className="input-values">
      {labelText && (
        <label className={labelClass} htmlFor={id || ''}>
          {labelText}
          {asterisk && <div className="asterisk">*</div>}
        </label>
      )}
      <textarea
        {...input}
        {...additional}
        placeholder={placeholder}
        id={id || ''}
        className={`form-item ${inputClassName} ${touched && error ? errorClassName : ''}`}
        autoFocus={focus}
        maxLength={maxLength}
      />
    </div>
    {counter && <div className="counter">{`${input.value.length}/${maxLength}`}</div>}

    {touched && error && showErrorText && <div className={errorClassName}>{error}</div>}
  </div>
);

TextAreaComponent.defaultProps = {
  labelText: '',
  labelClass: '',
  id: '',
  placeholder: '',
  counter: false,
  showErrorText: false,
  maxLength: null,
  focus: false,
  asterisk: false,
  additional: {},
  wrapperClassName: 'form-item-wrapper form-item-wrapper-textarea',
  inputClassName: 'form-item form-item-textarea',
  errorClassName: 'form-item-error',
};

TextAreaComponent.propTypes = {
  input: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  wrapperClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  maxLength: PropTypes.number,
  errorClassName: PropTypes.string,
  id: PropTypes.string,
  labelText: PropTypes.string,
  labelClass: PropTypes.string,
  meta: PropTypes.object.isRequired,
  showErrorText: PropTypes.bool,
  focus: PropTypes.bool,
  counter: PropTypes.bool,
  additional: PropTypes.object,
  asterisk: PropTypes.bool,
};

export default TextAreaComponent;
